import * as React from 'react';
import * as styles from './MortgageProgramItems.css';
import { EProgramType, ERealEstateType, IProgram } from '../../types/suburban';
import { STICKY_BUTTON_HEIGHT } from './constants';
import { ProgramItem, ProgramButton } from './components';

interface IMortgageProgramItemsProps {
  items: IProgram[];
  section: ERealEstateType;
  onButtonClick(id?: EProgramType): void;
}

export const MortgageProgramItems: React.VFC<IMortgageProgramItemsProps> = ({ items, section, onButtonClick }) => {
  const [showStickyButton, setShowStickyButton] = React.useState(false);

  const topItemRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const listenToScroll = () => {
      if (topItemRef.current) {
        const { top } = topItemRef.current.getBoundingClientRect();

        setShowStickyButton(window.innerHeight > top + STICKY_BUTTON_HEIGHT);
      }
    };

    listenToScroll();

    window.addEventListener('scroll', listenToScroll);

    return () => window.removeEventListener('scroll', listenToScroll);
  }, [topItemRef]);

  const handleButtonClick = React.useCallback(() => onButtonClick(), [onButtonClick]);

  return (
    <div className={styles['container']}>
      {items.map((item, index) => (
        <>
          <ProgramItem {...item} key={`${section}-${item.id}`} />
          {index === 0 && (
            <div ref={topItemRef}>{!showStickyButton && <ProgramButton onClick={handleButtonClick} />}</div>
          )}
        </>
      ))}
      {showStickyButton && <ProgramButton isSticky onClick={handleButtonClick} />}
    </div>
  );
};
